/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Enter_Website_UrlInputs */

const en_common_enter_website_url = /** @type {(inputs: Common_Enter_Website_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter website URL (e.g., example.com)`)
};

const es_common_enter_website_url = /** @type {(inputs: Common_Enter_Website_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa una URL (ej., example.com)`)
};

/**
* | output |
* | --- |
* | "Enter website URL (e.g., example.com)" |
*
* @param {Common_Enter_Website_UrlInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_enter_website_url = /** @type {((inputs?: Common_Enter_Website_UrlInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Enter_Website_UrlInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_enter_website_url(inputs)
	return en_common_enter_website_url(inputs)
});